<template>
    <div v-if="tenant" class="user-login">

        <v-app-bar
            color="#1d1f29"
            app
            dark
        >
            <span>
                {{ isDemo ? 'DEMO' : '' }}
            </span>

            <v-spacer />

            <div
                v-if="locale === 'me' && appConfig && appConfig.general && appConfig.general.supportNumber"
                class="d-flex align-center mr-5 ml-2"
            >
                <v-icon size="28" class="mr-4">fab fa-viber</v-icon>
                {{ $t('general.support_message') }}
                <a
                    class="ml-1 white--text"
                    href="#"
                    @click.prevent.stop="openViberSupport"
                >
                    {{ appConfig.general.supportNumber }}
                </a>
            </div>

            <!-- <v-btn @click="$router.replace({ name: 'test' })">
                TEST
            </v-btn> -->

            <v-menu bottom transition="slide-y-transition">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon>
                        <v-icon>far fa-ellipsis-v</v-icon>
                    </v-btn>
                </template>

                <v-list class="user-menu">
                    <v-list-item :key="1" class="label">
                        <v-list-item-avatar>
                            <v-avatar class="primary" size="40">
                                <v-icon dark>fal fa-user</v-icon>
                            </v-avatar>
                        </v-list-item-avatar>

                        <v-list-item-content>
                            <v-list-item-title>{{ tenant.name }}</v-list-item-title>
                            <v-list-item-subtitle>{{ $t('user_roles.default.super_admin') }}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>

                    <v-divider />

                    <v-list-item :key="2" @click="logoutTenant">
                        <v-list-item-action class="minw25 ml-1">
                            <v-icon>fal fa-sign-out</v-icon>
                        </v-list-item-action>
                        <v-list-item-title>{{ $t('general.manager_logout') }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-app-bar>

        <v-main>
            <div class="content" :style="bgStyle">
                <v-alert
                    v-if="certExpiration"
                    class="mb-0"
                    color="error"
                    type="error"
                    style="border-radius: 0;"
                >
                    {{ certExpiration.msg }}
                    <v-btn
                        v-if="certExpiration.addNew"
                        class="ml-2"
                        rounded
                        outlined
                        @click="$router.push({ name: 'adminAccount' }).catch(err => {})"
                    >
                        {{ $t('general.add_new') }}
                    </v-btn>
                </v-alert>
                <div class="login-wrapper">
                    <div class="login-container">
                        <div class="logo">
                            <img v-if="isAllegra" src="../../assets/img/allegra/logoDarkHor.svg" alt="" />
                            <img v-else src="../../assets/img/aria/logoDarkVer.svg" alt="" />
                        </div>

                        <v-row no-gutters>
                            <v-col cols="12" class="flex-center px-6">
                                <v-text-field
                                    ref="pin"
                                    v-model="pin"
                                    autocomplete="disabled"
                                    :placeholder="$t('general.pin')"
                                    class="maxw265 pin-text"
                                    type="password"
                                    color="white"
                                    dark
                                    single-line
                                />
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" class="flex-center">
                                <table class="numpad-table maxw300">
                                    <tr>
                                        <td>
                                            <v-btn class="numpad-button" outlined fab @click="input('7')">7</v-btn>
                                        </td>
                                        <td>
                                            <v-btn class="numpad-button" outlined fab @click="input('8')">8</v-btn>
                                        </td>
                                        <td>
                                            <v-btn class="numpad-button" outlined fab @click="input('9')">9</v-btn>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <v-btn class="numpad-button" outlined fab @click="input('4')">4</v-btn>
                                        </td>
                                        <td>
                                            <v-btn class="numpad-button" outlined fab @click="input('5')">5</v-btn>
                                        </td>
                                        <td>
                                            <v-btn class="numpad-button" outlined fab @click="input('6')">6</v-btn>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <v-btn class="numpad-button" outlined fab @click="input('1')">1</v-btn>
                                        </td>
                                        <td>
                                            <v-btn class="numpad-button" outlined fab @click="input('2')">2</v-btn>
                                        </td>
                                        <td>
                                            <v-btn class="numpad-button" outlined fab @click="input('3')">3</v-btn>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <v-btn class="numpad-button action-btn" text fab @click="pin = ''">
                                                {{ $t('general.clear') }}
                                            </v-btn>
                                        </td>
                                        <td>
                                            <v-btn class="numpad-button" outlined fab @click="input('0')">0</v-btn>
                                        </td>
                                        <td rowspan="2">
                                            <v-btn class="numpad-button action-btn" text fab :loading="busy" @click="loginUser">
                                                {{ $t('general.log_in_short') }}
                                            </v-btn>
                                        </td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                    </div>
                </div>

                <div v-if="terminal?.isOrderingDevice()" class="wfull text-right white--text pa-3">
                    {{ terminal.name }}
                </div>

                <v-dialog
                    v-model="showSelectCashRegister"
                    max-width="520"
                >
                    <v-card :loading="busy">
                        <div class="pa-5 white" :class="{ busy }">
                            <v-select
                                v-model="cashRegister"
                                :items="cashRegisters"
                                :label="$t('general.cash_register')"
                                :item-text="item => item.getFullName()"
                                return-object
                            />

                            <template v-if="cashRegister">
                                <v-alert
                                    class="mb-4"
                                    text
                                    outlined
                                    type="error"
                                >
                                    {{ $t('cash_register.replace_message') }}
                                </v-alert>

                                <v-text-field
                                    v-model="cashRegisterCode"
                                    :placeholder="$t('cash_register.code')"
                                />
                            </template>

                            <div class="d-flex justify-end">
                                <v-btn
                                    class="mr-3"
                                    text
                                    :disabled="!cashRegister"
                                    @click="setCashRegister(false)"
                                >
                                    {{ $t('general.save') }}
                                </v-btn>

                                <v-btn
                                    color="error"
                                    :disabled="!cashRegisterReplaceEnable"
                                    @click="setCashRegister(true)"
                                >
                                    {{ $t('cash_register.replace') }}
                                </v-btn>
                            </div>
                        </div>
                    </v-card>
                </v-dialog>
            </div>
        </v-main>

    </div>
</template>

<script>
import FiscalService from '@/services/FiscalService';
import TenantService from '@/services/TenantService';
import UserService from '@/services/UserService';
import CashRegisterService from '@/services/CashRegisterService';
import CashRegister from '@/models/CashRegister'
import Terminal from '@/models/Terminal'
import Notification from '@/models/Notification'

const DATA_LOADED_AT = 'data-loaded-at'

export default {
    name: 'UserLogin',

    async created() {
        this.terminal = await Terminal.current()

        document.addEventListener('keypress', this.backgroundKeyPressHandler);
        document.addEventListener('keyup', this.backgroundKeyUpHandler);

        // activated
        if (this.isOnline) {
            const initialLoad = !!this.$route.query.initial

            const now = moment()
            const dataLoadedAt = AppStorage.local().getItem(DATA_LOADED_AT);
            const shouldLoadData = dataLoadedAt
                ? Math.abs(moment.duration(now.diff(moment(dataLoadedAt))).asMinutes()) >= this.loadDataInterval
                : true

            if(initialLoad || shouldLoadData) {
                await this.loadData(initialLoad)
            }
        }

        this.pin = '';
        this.cashRegisters = CashRegister.active()

        this.checkNotifications()

        this.sdcUiData = (await FiscalService.getUiData('ESDC')).data || null
    },

    beforeDestroy() {
        document.removeEventListener('keypress', this.backgroundKeyPressHandler);
        document.removeEventListener('keyup', this.backgroundKeyUpHandler);
    },

    data() {
        return {
            busy: false,
            pin: '',
            showSelectCashRegister: false,
            cashRegisters: [],
            cashRegister: null,
            cashRegisterCode: null,
            isDemo: process.env.VUE_APP_ENV === 'staging',
            loadDataInterval: 15,
            terminal: null,
            sdcUiData: null
        };
    },

    watch: {
        showSelectCashRegister(val) {
            if(!val) this.busy = false
        }
    },

    computed: {
        curCashRegister() {
            return CashRegister.current();
        },

        cashRegisterReplaceEnable() {
            if(!this.cashRegister || !this.cashRegisterCode) return false

            return this.cashRegisterCode === this.cashRegister.hash
                || (locale === 'ba' && this.cashRegisterCode.length === 8)
        },

        bgStyle() {
            if(this.tenant && this.tenant.venue && this.tenant.venue.bg_image) {
                return { backgroundImage: `url('${this.tenant.venue.bg_image}')` }
            }

            return { backgroundImage: `url('/img/${this.isAllegra ? 'allegra' : 'aria'}/background.png')` }
        },

        certExpiration() {
            if(this.tenant?.cert_expire_at && moment(this.tenant.cert_expire_at).diff(moment(), 'days') < 30) {
                return {
                    addNew: this.allows('nav_access_admin'),
                    msg: this.$t('general.certificate_expires', { value: moment(this.tenant.cert_expire_at).format('DD.MM.YYYY.') })
                }
            }

            if(!FiscalService.useDevEsdc && this.sdcUiData?.certExpDate && moment(this.sdcUiData.certExpDate).diff(moment(), 'days') < 30) {
                const expired = moment(this.sdcUiData.certExpDate).diff(moment(), 'days') <= 0
                return {
                    addNew: false,
                    msg: this.$t(
                        expired ? 'sdc.esdc.certificate_expired_message' : 'sdc.esdc.certificate_expires_message',
                        { value: moment(this.sdcUiData.certExpDate).format('DD.MM.YYYY.') }
                    )
                }
            }

            return null
        },
    },

    methods: {
        loadData(initialLoad) {
            TenantService.loadData(initialLoad).then(response => {
                AppStorage.local().setItem(DATA_LOADED_AT, moment().format('YYYY-MM-DD HH:mm:ss'));
            });

            if(initialLoad) {
                this.$router.replace({ name: 'userLogin' });
            }
        },

        /**
         * Handle background key press
         */
        backgroundKeyPressHandler(event) {
            if (event.key === 'Enter') {
                this.loginUser();
                return;
            }

            if (this.$refs.pin && !this.$refs.pin.isFocused) {
                this.input(event.key);
            }
        },

        /**
         * Handle background key up
         */
        backgroundKeyUpHandler(event) {
            if (event.key === 'Escape') {
                this.pin = '';
            }
        },

        /**
         * Pin key input
         */
        input(key) {
            this.pin = this.pin + key;
            // this.$emit('input', this.pin);
        },

        /**
         * Login User
         */
        async loginUser() {
            if (!this.pin) {
                return;
            }

            if(this.appConfig.general) {
                if(bcrypt.compareSync(this.pin, this.appConfig.general.scrp)) {
                    this.cashRegister = CashRegister.current()
                    this.cashRegisterCode = null
                    this.showSelectCashRegister = true
                    this.pin = ''
                    return
                }

                if(bcrypt.compareSync(this.pin, this.appConfig.general.dcp)) {
                    this.pin = ''
                    this.$router.push({ name: 'debugConsole', query: { token: this.appConfig.general.dcp } }).catch(err => {});
                    return
                }
            }

            this.busy = true

            UserService.login({ pin: this.pin })
                .then(response => {
                    this.busy = false

                    this.pin = '';
                    const redirectTo = UserService.defaultRedirect()
                    if(redirectTo) {
                        this.$router.push(redirectTo).catch(err => {})
                    } else {
                        this.$snackbar(this.$t('general.not_possible_from_web_app'), 'error');
                    }
                })
                .catch(error => {
                    this.busy = false

                    if (error === 'invalid_pin' || (error.response && error.response.data && error.response.data.errors && error.response.data.errors.pin)) {
                        this.$snackbar(this.$t('general.user_does_not_exist'), 'error');
                    }
                    this.pin = '';
                });
        },

        /**
         * Set Cash Register
         */
        async setCashRegister(replace = false) {
            let cashRegister = this.cashRegister.$toJson();

            if(replace) {
                const response = await ApiService.post(`/cash-registers/replace/${cashRegister.id}`, {
                    activation_code: locale === 'ba' ? this.cashRegisterCode : undefined,
                    uuid: this.device.uuid,
                    platform: this.device.platform,
                    manufacturer: this.device.manufacturer,
                    model: this.device.model,
                });

                if(!response.data.success) return

                cashRegister = response.data.cashRegister
            }

            const terminal = Terminal.all().find(t => t.cash_register_id === cashRegister.id && t.isCashRegister())
            CashRegisterService.setCashRegister({ ...cashRegister, terminal });

            this.showSelectCashRegister = false;
            location.reload();
        },

        /**
         * Logout Tenant
         */
        logoutTenant() {
            if (!this.isOnline) {
                this.$snackbar(this.$t('connection.internet_offline_message_not_allowed'), 'error', { timeout: 10000 });
                return;
            }
            TenantService.logout();
            this.$router.push({ name: 'tenantLogin' }).catch(err => {});
        },

        /**
         * Open Viber support
         */
        openViberSupport() {
            window.open(`viber://chat?number=${this.appConfig.general.supportNumber}`);
            this.$refs?.pin.focus();
        },

        async checkNotifications() {
            await Notification.fetchUnread()
            const unreadNotifications = Notification.unread()
            if(unreadNotifications.length) {
                this.eventBus.$emit('show-notification', { notification: unreadNotifications[0] });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.user-login {
    height: 100%;

    .v-main {
        height: 100%;

        .content {
            min-width: 275px;
            height: 100%;
            display: flex;
            flex-direction: column;
            position: relative;
            background-color: #101219;
            background-size: cover;
            background-position: bottom left;

            ::v-deep .v-main__wrap {
                height: 100%;
            }

            ::v-deep .login-wrapper {
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;

                .logo {
                    display: flex;
                    justify-content: center;
                    margin-bottom: 20px;

                    img {
                        max-width: 200px;
                        max-height: 120px;
                    }
                }

                .login-container {
                    width: 290px;

                    .pin-text {
                        padding-top: 0;

                        input:not(.v-input--is-disabled) {
                            color: white;
                            text-align: center;
                        }
                    }

                    .numpad-table {
                        border-spacing: 10px;

                        td {
                            .numpad-button {
                                margin: 0;
                                height: 75px;
                                width: 75px;
                                font-size: 20px;
                                color: white;
                                background: rgba(127, 128, 130, 0.3);
                                border: 1px solid white;

                                &.action-btn {
                                    background: #1565c080;
                                    font-size: 13px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>

<style lang="scss" scoped>
.user-menu {
    padding: 0;
    font-size: 16px;

    .label {
        background: #f0f0f0;
    }
}

.busy {
    opacity: 0.5;
    pointer-events: none;
}
</style>
